import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "toast-container"
}
const _hoisted_2 = { class: "toast-icon" }
const _hoisted_3 = { class: "toast-content" }
const _hoisted_4 = { class: "toast-title" }
const _hoisted_5 = { class: "toast-message" }

import { computed, ref, watch, onBeforeUnmount } from 'vue'

interface Props {
  show: boolean
  type?: 'success' | 'error' | 'warning' | 'info'
  title?: string
  message?: string
  duration?: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ToastNotification',
  props: {
    show: { type: Boolean },
    type: { default: 'success' },
    title: { default: '' },
    message: { default: '' },
    duration: { default: 5000 }
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

let timeout: ReturnType<typeof setTimeout> | null = null

const iconClass = computed(() => {
  const icons = {
    success: 'fas fa-check-circle',
    error: 'fas fa-exclamation-circle',
    warning: 'fas fa-exclamation-triangle',
    info: 'fas fa-info-circle'
  }
  return icons[props.type] || icons.info
})

const handleClose = () => {
  if (timeout) {
    clearTimeout(timeout)
  }
  emit('close')
}

watch(
  () => props.show,
  (newVal) => {
    if (newVal && props.duration > 0) {
      timeout = setTimeout(() => {
        handleClose()
      }, props.duration)
    }
  }
)

onBeforeUnmount(() => {
  if (timeout) {
    clearTimeout(timeout)
  }
})

return (_ctx: any,_cache: any) => {
  return (__props.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["toast", __props.type])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("i", {
              class: _normalizeClass(iconClass.value)
            }, null, 2)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h4", _hoisted_4, _toDisplayString(__props.title), 1),
            _createElementVNode("p", _hoisted_5, _toDisplayString(__props.message), 1)
          ]),
          _createElementVNode("button", {
            class: "toast-close",
            onClick: handleClose
          }, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("i", { class: "fas fa-times" }, null, -1)
          ]))])
        ], 2)
      ]))
    : _createCommentVNode("", true)
}
}

})